<template>
  <div class="container">
      <div class="about">
          <div class="about-title">
              <h2>News<span>ニュース</span></h2>
          </div>
      </div>

      <div class="news-list">
        <div class="news-list-items" v-for="listItem in listItems" :key="listItem.id">
          <div class="news-list-item">
            <div><img src="@/assets/img/schedule.png" class="news-list-icon">{{ listItem.datetime }}</div>
            <div><a :href="listItem.anchorlink" v-smooth-scroll="{ duration: 1000, offset: -50 }">{{ listItem.title }}</a></div>
          </div>
        </div>
        <a href="javascript:void(0)" class="list-item-button"
          v-if="(listItems.length - count) >= 0" type="button" @click="isMore">More View</a>
      </div>
      
      <div class="news-details">
        <div class="news-detail" v-for="listItem in listItems" :key="listItem.id" :id="listItem.id">
          <div class="news-title">{{ listItem.title }}</div>
          <div class="news-tag">
            <img src="@/assets/img/schedule.png" class="news-icon"><span>{{ listItem.datetime }}</span>
            <img src="@/assets/img/folder.png" class="news-icon"><span>{{ listItem.category }}</span>
          </div>
          <div class="news-detail-content">
            <div v-if="listItem.image1" class="left-news-detail-content">
              <img v-if="listItem.image1" :src="listItem.image1">
              <a :href="listItem.caption" v-if="listItem.caption" class="news-caption" target="_blank">{{ listItem.caption }}</a>
            </div>
            <div class="right-news-detail-content">
              {{ listItem.content }}<br />
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import news from '@/api/news.js'

export default {
  head: {
    meta: [
      { name: 'description', content: 'これは個人ポートフォリオサイトです。Vue.jsを使って作ってします。' },
      { property: 'og:title', content: 'Newsページ' },
      { property: 'og:description', content: 'これは個人ポートフォリオサイトです。Vue.jsを使って作ってします。' },
      { property: 'og:type', content: 'article' },
      { property: 'og:url', content: 'https://example.com' },
      { property: 'og:image', content: 'https://example.com/img/og.png' },
      { name: 'twitter:card', content: 'summary' }
    ]
  },
  data () {
    return {
      count: 5
    }
  },
  computed: {
    listItems() {
      const list = news.fetch()
      return list.slice(0, this.count)
    }
  },
  methods: {
    isMore() {
        this.count += 10
    },
  },
}
</script>

<style scoped>
  .about {
      text-align: center;
  }
  .about .about-title {
      margin: 0 0 25px 0;
  }
  .about .about-title span {
      display: block;
      font-size: 12px;
  }
  .news-list,
  .news-detail {
    font-size: 14px;
    width: 60%;
    margin: 0 auto;
    padding: 50px;
    border-radius: 5px;
    background: #fff;
    filter: drop-shadow(0 0 2px rgba(0,0,0,.1));
  }
  .news-list {
    text-align: left;
    margin: 0 auto 70px;
    border-top: 5px solid #36839C;
  }
  .news-detail {
    text-align: left;
    margin: 0 auto 25px;
    border-top: 5px solid #F2999A;
  }
  .news-list .news-list-items .news-list-item {
    padding: 0 20px 0 0;
  }
  .news-list .news-list-items .news-list-item .news-list-icon {
    width: 15px;
    margin: 0 5px 0 0;
    bottom: 2px;
    position: relative;
  }
  .news-list .news-list-items .news-list-item a {
    color: #36839C;
  }
  .news-list .news-list-items {
    margin: 0 0 10px 0;
  }
  .news-list a {
    color: #36839C;
  }
  .news-detail .news-title {
    font-size: 20px;
    margin: 0 0 10px 0;
  }
  .news-detail .news-tag {
    font-size: 10px;
    margin: 0 0 35px 0;
  }
  .news-detail .news-tag .news-icon {
    width: 10px;
    margin: 0 5px 0 0;
    bottom: 2px;
    position: relative;
  }
  .news-detail .news-tag span {
    font-family: sans-serif;
    margin: 0 10px 0 0;
  }
  .news-detail .news-detail-content {
    display: flex;
    justify-content: space-between;
  }
  .news-detail .news-detail-content .left-news-detail-content {
    width: 100%;
  }
  .news-detail .news-detail-content .left-news-detail-content img {
    width: 100%;
    margin: 0 0 10px 0;
    padding: 0 20px 0 0;
  }
  .news-detail .news-detail-content .left-news-detail-content .news-caption {
    font-size: 10px;
    font-family: sans-serif;
  }
  .news-detail .news-detail-content .right-news-detail-content {
    text-align: justify;
    font-size: 12px;
    font-family: sans-serif;
    line-height: 2.1em;
    width: 100%;
    bottom: 5px;
    position: relative;
  }
  @media screen and (max-width:768px) {
    .news-list,
    .news-detail {
      width: 90%;
      padding: 25px;
    }
    .news-detail .news-detail-content {
      display: block;
    }
    .news-detail .news-tag {
      margin: 0 0 20px 0;
    }
    .news-detail .news-detail-content .left-news-detail-content img {
      padding: 0;
    }
    .news-detail .news-detail-content .left-news-detail-content .news-caption {
      margin: 0 0 30px 0;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/News.vue